//#region src/components/ScalarForm/ScalarFormSection.vue?vue&type=script&lang.ts
/**
* Scalar Form Section component
*
* A collection of form fields grouped together with a title.
*
* @example
*   <ScalarFormSection>
*     <template #label>Section Label</template>
*     <!-- Section content -->
*   </ScalarFormSection>
*/
var ScalarFormSection_vue_vue_type_script_lang_default = {};
//#endregion
export { ScalarFormSection_vue_vue_type_script_lang_default as default };

//# sourceMappingURL=ScalarFormSection.vue.script.js.map